import { NodeWrapper } from "./NodeWrapper";
import React, { memo, useEffect, useState, useCallback } from "react";
import { Box, Typography,  Chip, Paper,  } from "@mui/material";
import { useTheme } from "@material-ui/core/styles";
import './css/inputNode.css'; // Reusing input node styles for base look
import { Poll as PollIcon, Code as VariablesIcon, ContentCopy as ContentCopyIcon, DeleteOutline as DeleteOutlineIcon, Save as SaveIcon } from '@mui/icons-material';
import { i18n } from "../../../translate/i18n";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { processVariablesInText } from "../../../utils/variableUtils";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));
export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const storageItems = useNodeStorage();
  const [processedQuestion, setProcessedQuestion] = useState(data.question || "");
  const [variableValue, setVariableValue] = useState("");
  const [isExecutionMode, setIsExecutionMode] = useState(false);
  const extractVariables = text => {
    if (!text) return [];
    const regex = /\$\{([^}]+)\}/g;
    const matches = [];
    let match;
    while ((match = regex.exec(text)) !== null) {
      matches.push(match[1]);
    }
    return [...new Set(matches)];
  };
  const updateProcessedQuestion = useCallback(() => {
    const originalText = data.question || "";
    const newText = processVariablesInText(originalText);
    setProcessedQuestion(newText);
  }, [data.question]);
  useEffect(() => {
    const isExecutionPath = !window.location.pathname.includes('/flowbuilder-config');
    setIsExecutionMode(isExecutionPath);
    if (isExecutionPath && data.variableName) {
      const checkVariableValue = () => {
        if (window.flowVariables && window.flowVariables[data.variableName]) {
          setVariableValue(window.flowVariables[data.variableName]);
        }
      };
      checkVariableValue();
      const intervalId = setInterval(checkVariableValue, 1000);
      return () => clearInterval(intervalId);
    }
  }, [data.variableName]);
  useEffect(() => {
    updateProcessedQuestion();
    const handleVariableUpdate = () => {
      updateProcessedQuestion();
    };
    window.addEventListener('flowVariableUpdate', handleVariableUpdate);
    return () => {
      window.removeEventListener('flowVariableUpdate', handleVariableUpdate);
    };
  }, [data.question, updateProcessedQuestion]);
  return <NodeWrapper id={id} selected={selected} color="#3F51B5">
      <Handle type="target" position="left" style={{
      left: -12,
      top: "20px",
      background: "#3F51B5",
      width: 10,
      height: 20,
      cursor: 'pointer',
      borderRadius: "4px",
      border: '2px solid white',
      zIndex: 1
    }} isConnectable={isConnectable} />

      {/* Floating Toolbar */}
      

      {/* Main Card */}
      
        {/* Header */}
        <Box sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      p: 1.5,
      borderBottom: "1px solid #f1f5f9",
      
      bgcolor: "#3F51B5",
      backgroundImage: "linear-gradient(rgba(0,0,0,0.12), rgba(0,0,0,0.12))",
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px",
      color: "#ffffff"
    }}>
          <Box sx={{
        display: "flex", alignItems: "center", gap: 1, flexGrow: 1
      }}>
            <PollIcon sx={{ width: "20px", height: "20px", color: "#ffffff", filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.7))" }} />
            <div style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700", letterSpacing: "0.3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textShadow: "0px 1px 4px rgba(0,0,0,0.8)" }}>
              {(/^Nodo\s*[\d\s]*$/i.test(data.name || "") ? (i18n.t("flowBuilder.editor.nodes.poll.name") + " " + (data.name.match(/\d+/) ? data.name.match(/\d+/)[0] : "")) : (data.name || i18n.t("flowBuilder.editor.nodes.poll.name")))}
</div>
          
        <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
          <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.poll.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.poll.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
        </div>
</Box>
        </Box>

        {/* Content */}
        <Box sx={{
      p: 1.5,
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5
    }}>
          <Paper elevation={0} sx={{
        bgcolor: '#f8fafc',
        p: 1.5,
        borderRadius: 1,
        minHeight: '60px',
        overflow: 'auto',
        maxHeight: '150px',
        wordBreak: 'break-word',
        border: '1px solid #f1f5f9'
      }}>
            <Typography variant="caption" color="text.secondary" sx={{
          display: 'block',
          mb: 0.5,
          fontWeight: 400,
          fontFamily: "'Inter', 'Roboto', sans-serif"
        }}>
              {i18n.t("flowBuilder.editor.nodes.poll.question")}:
            </Typography>

            {data.question ? <Typography variant="body2" color="#334155">{processedQuestion}</Typography> : <Typography variant="body2" color="text.secondary" sx={{
          fontStyle: 'italic',
          fontSize: '13px'
        }}>
                {i18n.t("flowBuilder.editor.nodes.input.undefinedQuestion")}
              </Typography>}
          </Paper>

          {data.options && data.options.length > 0 && <Box sx={{ position: 'relative' }}><Paper elevation={0} sx={{
        bgcolor: '#f8fafc',
        p: 1,
        borderRadius: 1,
        wordBreak: 'break-word',
        border: '1px solid #f1f5f9',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5
      }}>
              <Typography variant="caption" color="text.secondary" sx={{
          fontWeight: 400,
          fontFamily: "'Inter', 'Roboto', sans-serif"
        }}>
                {i18n.t("flowBuilder.editor.nodes.poll.options")} ({data.options.length}):
              </Typography>
              {data.options.map((opt, idx) => <Typography key={idx} variant="body2" sx={{
          fontSize: '12px',
          color: "#ffffff",
          background: '#e0f2fe',
          padding: '2px 6px',
          borderRadius: '4px',
          width: 'fit-content'
        }}>
                   • {opt}
                 </Typography>)}
            </Paper>
            <Handle type="source" position="right" id="a" style={{
              position: "absolute", right: -24, top: "50%", transform: "translateY(-50%)", background: "#3F51B5", width: 10, height: 20, cursor: 'pointer', borderRadius: "4px", border: '2px solid white', zIndex: 1
            }} isConnectable={isConnectable} />
          </Box>}

          <Paper elevation={0} sx={{
        bgcolor: '#f8fafc',
        p: 1,
        borderRadius: 1,
        minHeight: '40px',
        overflow: 'auto',
        wordBreak: 'break-word',
        border: '1px solid #f1f5f9',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
            <Typography variant="caption" color="text.secondary" sx={{
          fontWeight: 400,
          fontFamily: "'Inter', 'Roboto', sans-serif"
        }}>
              {i18n.t("flowBuilder.editor.nodes.poll.variableLabel")}:
            </Typography>

            {data.variableName ? <Box sx={{
          display: 'flex',
          alignItems: 'center'
        }}>
                <Chip label={data.variableName} size="small" sx={{
            height: 24,
            fontSize: '0.85rem',
            bgcolor: '#fff',
            color: "#ffffff",
            border: '1px solid #e2e8f0',
            '& .MuiChip-label': {
              px: 1.5
            }
          }} />
              </Box> : <Typography variant="body2" color="text.secondary" sx={{
          fontStyle: 'italic',
          fontSize: '12px'
        }}>
                {i18n.t("flowBuilder.editor.nodes.input.undefinedVariable")}
              </Typography>}
          </Paper>

          {data.question && data.question.includes("${") && <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mt: 0.5,
        bgcolor: '#fdf4ff',
        p: 0.75,
        borderRadius: 1
      }}>
              <VariablesIcon fontSize="small" sx={{
          color: '#d946ef',
          width: 16,
          height: 16
        }} />
              <Typography variant="caption" sx={{
          color: '#d946ef'
        }}>
                {i18n.t("flowBuilder.editor.nodes.input.usingVariables")}: {extractVariables(data.question).join(', ')}
              </Typography>
            </Box>}
        </Box>
      

      
    </NodeWrapper>;
});
